/**
 * useAnswerTestAsk - a player rolls the test the GM asked of them (v9.5.3).
 *
 * An ordinary prompt carries the call (engine/narrative/testAsk); it is
 * rolled HERE, with this screen's dice (engine/dice, so E2E's seeded
 * sequence drives it) against the roster this screen holds, and the
 * result goes back as the ask's answer (testAnswer.ts). A secret prompt
 * carries no call: the answer is the signal `true`, and the GM's screen
 * rolls. Anything a console could forge here, it could already read; the
 * secret path is the one the rules protect, and it never comes this way.
 *
 * @param {object} args - roster, asks (useAsks), unnaturalDosMode, assistBonus
 * @returns {{ roll: (ask) => void }}
 */
import { useCallback, useRef } from 'react';
import { resolveTestCall } from '../engine/narrative/callForTest';
import { readTestAsk } from '../engine/narrative/testAsk';
import { testAnswerOf } from '../engine/narrative/testAnswer';

export default function useAnswerTestAsk(args) {
  const live = useRef(args);
  live.current = args;
  const roll = useCallback((ask) => {
    const now = live.current;
    const prompt = readTestAsk(ask.payload);
    if (!prompt?.call) return now.asks.answer(ask.id, true);
    const opts = { unnaturalDosMode: now.unnaturalDosMode, assistBonus: now.assistBonus };
    const [result] = resolveTestCall(prompt.call, now.roster, opts);
    // The person is not on this screen's roster yet: let the GM's screen roll, as before.
    now.asks.answer(ask.id, result ? testAnswerOf(prompt, result) : true);
  }, []);
  return { roll };
}
